var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContinueAfterFailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 31,
    viewBox: "0 0 42 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 5H36.75C38.8211 5 40.5 6.67893 40.5 8.75V8.75C40.5 10.8211 38.8211 12.5 36.75 12.5H28.2895C27.025 12.5 26 13.525 26 14.7895L26 27.5",
    stroke: "#002858",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5H19",
    stroke: "#002858",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H19",
    stroke: "#002858",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21H19",
    stroke: "#002858",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 29H19",
    stroke: "#002858",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2121 30.7879L30.4879 26.5121C30.6769 26.3231 30.543 26 30.2757 26L21.7243 26C21.457 26 21.3231 26.3231 21.5121 26.5121L25.7879 30.7879C25.905 30.905 26.095 30.905 26.2121 30.7879Z",
    fill: "#002858"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.5C21.7399 0.5 19.5 2.73986 19.5 5.5C19.5 8.26014 21.7399 10.5 24.5 10.5C27.2601 10.5 29.5 8.26014 29.5 5.5C29.5 2.73986 27.2601 0.5 24.5 0.5Z",
    fill: "#FF005B",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinueAfterFailIcon);
export default __webpack_public_path__ + "static/media/continueAfterFailIcon.79a9251a.svg";
export { ForwardRef as ReactComponent };